import { inject, Injectable } from '@angular/core';

import { useRolloutPlanStore } from '../../../+state/rollout/rollout-plan.store';

@Injectable({
  providedIn: 'root'
})
export class PlanDetailsService {
  private store = inject(useRolloutPlanStore);

  loadAllRolloutPlanEligiblePackages() {
    return this.store.loadRolloutPlanEligiblePackages();
  }
}
